import { messagesSentPerDayGauge } from 'ducks/reports/gauges/definitions/messagesSentPerDayGauge'
import { HeadlineVisualization } from 'ducks/reports/visualizations'

const staticProps = {
  gauges: [messagesSentPerDayGauge],
}
export default function MessagesSentPerDayHeadline(props) {
  return <HeadlineVisualization {...props} {...staticProps} />
}
